package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_05_17_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who are seeking a Shard of Concar in a natural cavern deep underground, claimed by the Aboleth Flar’Melkhis, protected by an army of Chuul, some humanoids of unknown origin, and a Death Slaad. While Flar’Melkhis did enslave Bigglesworth, Caper is channeling chill vibes, temporarily interrupting the mind control.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A Chuul attacks Caper and grapples her, but Bigglesworth dismembers the aberration. Through some advanced sorcery, Tuesday transmutes the fire of a fireball into lightning and unleashes it on the enemies standing in shallow water.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("You will pay for that!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Flar’Melkhis strikes down Korvis. Dusk attempts to banish Tuesday, but Caper counterspells and then flies to Dusk and attacks. Dirk creates a wall of flames cutting off Vernal and Fitzgeorge from Flar’Melkhis and the heroes. Dusk drops her defenses and tries to flee, but Caper kills her. Korvis transforms himself into a giant shark. Flar’Melkhis looks at Tuesday.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("I see you creature of the Fey! You shall be mine.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday finishes off Fitzgeorge. Caper is interrupted, and the demons in Bigglesworth’s head return.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Flar’Melkhis offers to leave and not fight to the death. Vernal surrenders and then grabs Flar’Melkhis, and they teleport away. Bigglesworth’s enslavement ends, and he feels that Flar’Melkhis is far away.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes loot the Shard of Concar.")
    }
}
